import React from 'react';
import CountUp from '../../components/Reactbits/Count';

import  WhyChooseAs1  from './../../assets/images/team/why-we-1.png';
import  WhyChooseAs2  from './../../assets/images/team/why-we-2.png';
import  WhyChooseAs3  from './../../assets/images/team/why-we-3.png';

const WhyChoseAs    = () => {


    const whyChooseAs = [
        {
            count: "200+",
            title: 'Cities Covered',
           image:   WhyChooseAs1
        },
        {
            count: "30000",
            title: 'Reliable',
            image: WhyChooseAs2
        },
        {
            count: "10000",
            title: 'Cost-Effective',
            image: WhyChooseAs3
        }
    ]




    return (
        <div  style={{margin: '60px  50px',borderRadius: '20px',paddingLeft: '50px',paddingTop: '60px'}} className=''>
            <div className='row'>
                <div className='col-md-5'>
                <h2 style={{fontWeight: '700', color: '#006FB4',fontFamily: 'Montserrat',fontSize: '42px'}} >Why
                        <br></br>
                    Choose Us</h2>
                    <p style={{fontWeight: '500', color: 'black',fontFamily: 'Montserrat',fontSize: '18px',paddingRight: '200px' }} >
                    Fast, reliable, and cost-effective logistics solutions. On-time delivery with seamless tracking. Your trusted partner in supply chain efficiency.
                    </p>

                </div>
                <div  className='col-md-7'>
                    {whyChooseAs.map((item, index) => (
                        <div key={index} className='d-flex justify-content-between mb-4' >
                            <div className=''>
                                <h3 style={{fontWeight: '800', color: '#006FB4',fontFamily: 'Montserrat',fontSize: '92px'}} >
                                    <CountUp to={item.count} duration={2} />
                                </h3>
                                <p style={{fontWeight: '500', color: 'black',fontFamily: 'Montserrat',fontSize: '30px'}} >{item.title}</p>
                            </div>
                            <div className=''>
                                <img  style={{width: '273px', height: '145px', borderRadius: '20px',objectFit: 'cover'   }} className='img-responsive' src={item.image} alt={item.title} />
                            </div>
                            
                        </div>
                    ))}

                </div>
            </div>



        </div>
    );
}

export default WhyChoseAs
;


